import { Link } from "react-router-dom";
import leapLogo from "../assets/images/leap-logo.svg";
import vodoLogo from "../assets/images/Vodo-logo.svg";
import logo2 from "../assets/images/logo2.svg";
import logo3 from "../assets/images/logo3.png";
import logo4 from "../assets/images/logo4.png";
import logo5 from "../assets/images/logo5.png";
import foooter from "../assets/images/foooter.svg";

function Footer() {
  return (
    <>
      <footer className="leap-bg-[#191733] leap-text-white leap-py-10 leap-px-4">
        <div className="leap-container leap-mx-auto leap-flex leap-flex-col leap-items-center">
          {/* Logo Section */}
          {/* <div className="leap-flex leap-flex-col leap-items-center leap-mb-6">
            <Link to="/" className="leap-text-white">
              <img
                src={leapLogo}
                alt="leap logo"
                className="leap-h-16"
                loading="lazy"
              />
            </Link>
          </div> */}

          {/* Contact Info Section */}
          {/* <div className="leap-grid leap-place-items-center leap-gap-10 leap-grid-cols-4 lg:leap-grid-cols-3 leap-gap-y-14 leap-w-full sm:leap-w-auto leap-mt-5">
            <div className="leap-flex leap-flex-col leap-gap-3 leap-col-span-2 lg:leap-col-span-1">
              <h3 className="leap-text-[15px] leap-text-[#73FAFD]">Phone:</h3>
              <p className="leap-text-[#73FAFD] leap-text-xs">
                +966- 456 - 7890
              </p>
            </div>

            <div className="leap-flex leap-flex-col leap-gap-3 leap-col-span-2 lg:leap-col-span-1">
              <h3 className="leap-text-[15px] leap-text-[#73FAFD]">Email:</h3>
              <p className="leap-text-[#73FAFD] leap-text-xs">
                Email@yourmail.com
              </p>
            </div>

            <div className="leap-flex leap-flex-col leap-gap-3 leap-text-center lg:leap-text-start leap-col-span-4 lg:leap-col-span-1">
              <h3 className="leap-text-[15px] leap-text-[#73FAFD]">Address:</h3>
              <p className="leap-text-[#73FAFD] leap-text-xs">
                123 Anywhere St., Any City, ST 12345
              </p>
            </div>
          </div> */}
         {/* <h1 className="leap-text-center leap-text-xl md:leap-text-3xl leap-mt-5 leap-mb-5 md:leap-mb-12 leap-font-bold">
            Co-organised by
          </h1> */}

         {/*   <div className="leap-grid leap-place-items-center leap-gap-10 leap-grid-cols-4 lg:leap-grid-cols-6  leap-w-full sm:leap-w-auto leap-mt-10">
            <div className="leap-gap-1 leap-col-span-3 lg:leap-col-span-3 sm:leap-col-span-4">
              <img
                src={logo4}
                alt="leap logo"
                className="leap-h-12 sm:leap-h-16 lg:leap-h-24 mx-auto"
                loading="lazy"
              />
            </div>

            <div className="leap-gap-1 leap-col-span-3 lg:leap-col-span-3 sm:leap-col-span-4">
              <img
                src={logo5}
                alt="leap logo"
                className="leap-h-14 sm:leap-h-18 lg:leap-h-28 mx-auto"
                loading="lazy"
              />
            </div>

            <div className="leap-gap-1 leap-col-span-3 lg:leap-col-span-6 sm:leap-col-span-4">
              <img
                src={logo2}
                alt="leap logo"
                className="leap-h-12 sm:leap-h-16 lg:leap-h-32 mx-auto"
                loading="lazy"
              />
            </div>

            <h1 className="leap-font-bold leap-text-center leap-mx-auto leap-text-base lg:leap-text-xl leap-col-span-4 lg:leap-col-span-6">
              SME Partner
            </h1>

            <div className="leap-gap-1 leap-col-span-3 lg:leap-col-span-6 sm:leap-col-span-4">
              <img
                src={logo3}
                alt="leap logo"
                className="leap-h-24 sm:leap-h-32 lg:leap-h-48 mx-auto"
                loading="lazy"
              />
            </div>
          </div> */}

          <img
            src={foooter}
            alt="leap logo"
            className="leap-h-fit sm:leap-h-[50vh] lg:leap-h-[50vh] leap-mx-auto"
            loading="lazy"
          />

          {/* Last design */}
          {/* <div className="leap-flex leap-items-center leap-justify-center leap-my-5 leap-pr-5 leap-gap-10">
            <p className="leap-pt-2 leap-text-[12px] sm:leap-text-[14px] lg:leap-text-xl leap-font-semibold">
              Organized By Tahaluf
            </p>
            <img
              src={logo2}
              alt="leap logo"
              className="leap-h-6 sm:leap-h-10 lg:leap-h-16 leap-hover:opacity-80 leap-transition-opacity leap-duration-300"
              loading="lazy"
            />
          </div> */}
        </div>
      </footer>
      <div className="leap-flex leap-py-2 leap-gap-2 leap-justify-center leap-bg-[#E1E1E1]">
        <div className="">
          <span>Powered By </span>
        </div>
        <div className="">
          <img src={vodoLogo} alt="vodo logo" className="" loading="lazy" />
        </div>
      </div>
    </>
  );
}

export default Footer;
